import React from 'react';
import Slider from "react-slick";

import davichi01 from '../images/0001.jpg';
import davichi02 from '../images/0002.jpg';
import davichi03 from '../images/0003.jpg';
import davichi04 from '../images/0004.jpg';
import davichi05 from '../images/0005.jpg';
import davichi06 from '../images/0006.jpg';
import davichi07 from '../images/0007.jpg';
import davichi08 from '../images/0008.jpg';
import davichi09 from '../images/0009.jpg';

import { Wrap, NextBtnStd, PrevBtnStd } from './styled';

function PrevBtn(props) {
  const { onClick } = props;

  return (
    <PrevBtnStd onClick={onClick}>
      <svg width="50" height="50" viewBox="0 0 50 50">
        <g fill="none" fillRule="evenodd">
          <path fill="#000" d="M0 0h50v50H0z"/>
          <path stroke="#FFF" d="M22 16l9 9-9 9"/>
        </g>
      </svg>
    </PrevBtnStd>
  );
}

function NextBtn(props) {
  const { onClick } = props;

  return (
    <NextBtnStd onClick={onClick}>
      <svg width="50" height="50" viewBox="0 0 50 50">
        <g fill="none" fillRule="evenodd">
          <path fill="#000" d="M0 0h50v50H0z"/>
          <path stroke="#FFF" d="M22 16l9 9-9 9"/>
        </g>
      </svg>
    </NextBtnStd>
  );
}

function DavichForm() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextBtn />,
    prevArrow: <PrevBtn />,
  };

  return (
    <Wrap>
      <Slider {...settings}>
        <div>
          <img src={davichi01} />
        </div>
        <div>
          <img src={davichi02} />
        </div>
        <div>
          <img src={davichi03} />
        </div>
        <div>
          <img src={davichi04} />
        </div>
        <div>
          <img src={davichi05} />
        </div>
        <div>
          <img src={davichi06} />
        </div>
        <div>
          <img src={davichi07} />
        </div>
        <div>
          <img src={davichi08} />
        </div>
        <div>
          <img src={davichi09} />
        </div>
      </Slider>
    </Wrap>
  );
}

export default DavichForm;
